import {tgxApi} from "./tgxApi";
import {getAuthorizationHeader, handleQueryError} from "../helpers/utils/RtkQueryUtils";

export const globalApi = tgxApi.injectEndpoints({
    endpoints: (build) => ({
        getEnums: build.query({
            query: () => ({
                url: `/utility/tgx/enums`,
                method: "GET",
                headers: getAuthorizationHeader()
            }),
            async onQueryStarted(_, {queryFulfilled,}) {
                await handleQueryError(queryFulfilled)
            },
        }),
    }),
})

export const {
    useGetEnumsQuery
} = globalApi;